import { redirect } from '@tanstack/react-router';

import type { RouterContext } from '@/routes/__root';

export const redirectUnauthenticated = (context: RouterContext) => {
  if (!context.auth.isAuthenticated) {
    throw redirect({ to: '/' });
  }
};
